'use client';

import { Menu as MuiMenu } from '@mui/material';

import { useMenuContext } from './MenuProvider';

import type { MenuProps } from '@mui/material';
import type { FC } from 'react';

export type MenuProviderProps = Omit<MenuProps, 'open'>;

const defaultMenuProps = {
  'aria-labelledby': 'basic-button',
};

/**
 * provides management of the anchor element and open/close state of the PopoverDisplay
 * requires a <AnchorElement> to consume event handler
 *
 * @example
 * ```jsx
 *   <PopperProvider>
 *     <PopoverDisplay>
 *       <AnchorElement>
 *         <MenuItem>Profile</MenuItem>
 *       </AnchorElement>
 *       <AnchorElement>
 *         <MenuItem>My account</MenuItem>
 *       </AnchorElement>
 *       <AnchorElement>
 *         <MenuItem>Logout</MenuItem>
 *       </AnchorElement>
 *     </PopoverDisplay>
 *   </PopperProvider>
 * ```
 */

export const MenuDisplay: FC<MenuProviderProps> = ({
  children,
  id = 'menu',
  MenuListProps = defaultMenuProps,
  ...props
}) => {
  const { anchorEl, onClose, open } = useMenuContext();

  return (
    <MuiMenu
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={MenuListProps}
      {...props}
    >
      {children}
    </MuiMenu>
  );
};
